import { Col, Form, message, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingSpin from '../../loadingSpin/LoadingSpin';
import DashboardService from '../../../services/DashboardService';
import TableViewActiveKanban from './TableViewActiveKanban';
import ReportService from '../../../services/ReportService';
import ResponseMessage from '../../Comman/Notification/ResponseMessge';

const ViewActiveKanban = ({ userData }) => {
    const [lineData, setLineData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [getActiveKanban, setGetActiveKanban] = useState(null);
    const [sizeData, setSizeData] = useState([]);

    useEffect(() => {
        const getLineData = async () => {
            try {
                const response = await DashboardService.getLine();

                if (response?.line_no) {
                    const Option = response.line_no.map(line => ({
                        label: line,
                        value: line,
                    }));
                    setLineData(Option);
                } else {
                    ResponseMessage.error({ message : response?.message || 'Failed to fetch line data'});
                }
            } catch (error) {
                console.error("Error fetching line data:", error);
                ResponseMessage.error({ message : 'Failed to fetch line data'});
            }
        };

        getLineData();
    }, []);

    const handleGetData = async (value) => {
        setIsLoading(true);
        try {
            const response = await ReportService.displayActiveKanban(value);

            if (response?.data?.length > 0) {
                setGetActiveKanban(response.data);

                try {
                    // Iterate over the data array and parse each `size_name`
                    const expandDataSource = response.data.flatMap((item) => {
                        const sizes = item.size_name ? JSON.parse(item.size_name) : {};
                        return Object.entries(sizes)
                            .filter(([size, qty]) => qty && qty !== "")
                            .map(([size, qty]) => ({
                                kb_number: item.kb_number,
                                size,
                                size_qty: qty,
                            }));
                    });

                    // console.log(expandDataSource);
                    setSizeData(expandDataSource);
                } catch (jsonError) {
                    console.error("Error parsing size data:", jsonError);
                    setSizeData([]);
                }
            } else {
                setGetActiveKanban(null);
                setSizeData([]);
                ResponseMessage.error({ message : 'No data received from server'});
            }
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
            setGetActiveKanban(null);
            setSizeData([]);
            ResponseMessage.error({ message : 'Failed to fetch kanban data'});
        } finally {
            setTimeout(() => setIsLoading(false), 1000);
        }
    };


    return (
        <>
            <Row gutter={54} justify="end" align="top">
                <Col span={8}>
                    <Form.Item name="selectLine" label="Select Line">
                        <Select
                            getPopupContainer={(trigger) => trigger.parentNode}
                            options={lineData}
                            onChange={handleGetData}
                            placeholder="Select a line"
                        />
                    </Form.Item>
                </Col>
            </Row>
            <div style={{ position: 'relative', minHeight: '200px' }}>
                {isLoading && (
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 10,
                    }}>
                        <LoadingSpin />
                    </div>
                )}
                {getActiveKanban && (
                    <TableViewActiveKanban
                        getActiveKanban={getActiveKanban}
                        sizeData={sizeData}
                    />
                )}
            </div>
        </>
    );
};

export default ViewActiveKanban;